import * as React from "react";
import { useContext } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { Grid, useTheme } from "@mui/material";
import { GlobalContext } from "../Utils/Contexts";
import dayjs from "dayjs";
import { saveTicketChanges } from "../Utils/TicketDatabase";

interface Props {
    confirmSignaturePending(isConfirmed: boolean): void;
    showForceReloadDialogue(): void;
}

export default function SignaturePendingDialog(props: Props): JSX.Element {
    const context = useContext(GlobalContext);
    const theme = useTheme();

    function handleClose(): void {
        props.confirmSignaturePending(false);
    }

    async function handleCompleteTicket(): Promise<void> {
        const toMerge = {
            signature_pending: 1,
            completed_date: dayjs().toISOString(),
        };

        await saveTicketChanges(context.selectedTicketId, toMerge).catch(() => props.showForceReloadDialogue());

        props.confirmSignaturePending(true);
    }

    return (
        <Dialog open={true}>
            <Grid container sx={{ p: 2 }}>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Typography component="h1" variant="h6">
                        COMPLETE WITHOUT SIGNATURE?
                    </Typography>
                </Grid>
                <Grid container item xs={12} sx={{ pt: 3 }}>
                    <Grid item flex={1}>
                        <Typography textAlign={"center"} sx={{ p: 1, pb: 2 }}>
                            PRESSING CONTINUE COMPLETES THE TICKET AND ALLOWS YOU TO EMAIL THE PDF. THIS OPTION SHOULD ONLY BE USED IF THE CUSTOMER IS UNAVAILABLE TO SIGN.
                        </Typography>
                        <Typography textAlign={"center"} color={theme.palette.error.main} sx={{ p: 1, pb: 4 }}>
                            CONTINUING MAKES THE TICKET READ-ONLY. ANY FUTURE CHANGES WILL REQUIRE YOU TO COMPLETE A REVISED TICKET.
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Button variant="contained" sx={{ m: 1 }} onClick={handleClose}>
                        CANCEL
                    </Button>
                    <Button variant="contained" sx={{ m: 1 }} onClick={handleCompleteTicket}>
                        CONTINUE
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );
}
